import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) return <div className="p-20 text-center font-mono">Loading…</div>;
    if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
    return children;
}

export function AdminRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="p-20 text-center font-mono">Loading…</div>;
    if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
    return children;
}
